









































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapMutations } from 'vuex';
import { CatalogV1StageListRequest, StageImageResponse } from '@/requests/mainApi';
// @ts-ignore
import VueSlickCarousel from 'vue-slick-carousel';

interface IConstructionStages {
  stages: StageImageResponse[];
}

interface Data {
  currentMediaCount: number;
  localLink: string;
  goBackLink: string;
  viewType: 'photos' | 'videos';
  constructionStages: IConstructionStages;
  currentStage: StageImageResponse | null;
}

interface Methods {
  getConstructionStages: (payload: CatalogV1StageListRequest) => Promise<StageImageResponse[]>;
  getYoutubeVideoID: (url: string) => string;
}

interface Computed {
  currentCount: string;
}

interface Props {}

export default Vue.extend({
  name: 'ConstructionStages',
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      currentMediaCount: 1,
      goBackLink: '/profile',
      viewType: 'photos',
      constructionStages: {},
      currentStage: null,
    };
  },
  async created() {
    if (!this.$route.params.id) return;

    const stages = await this.getConstructionStages({
      house: String(this.$route.params.id),
    });
    if (!stages.length) return;

    this.constructionStages = {
      stages,
    };
  },
  computed: {
    currentCount() {
      if (!this.currentStage) {
        return '';
      }

      if (this.viewType === 'photos') {
        if (this.currentStage.images.length <= 1) {
          return '';
        }
        return `${this.currentMediaCount} ${this.$t('app.profile.progress.of')} ${this.currentStage.images.length} ${(
          this.$t('app.profile.progress.photos') as string
        )
          .slice(0, 4)
          .toLowerCase()}`;
      }

      if (this.currentStage.videos.length <= 1) {
        return '';
      }

      return `${this.currentMediaCount} ${this.$t('app.profile.progress.of')} ${this.currentStage.videos.length} ${(
        this.$t('app.profile.progress.videos') as string
      ).toLowerCase()}`;
    },
  },
  methods: {
    getYoutubeVideoID(url: string) {
      if (url && typeof url === 'string') {
        const splitedUrl = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);

        if (splitedUrl[2] !== undefined) {
          return splitedUrl[2].split(/[^0-9a-z_-]/i)[0];
        }

        return url;
      }

      return url;
    },
    afterPageChange(page: number) {
      this.currentMediaCount = page + 1;
    },
    ...mapActions(['getConstructionStages']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
